// Constants for strings
export const LOGIN = "Login";
export const CREATE_ACCOUNT = "Create an Account";
